export const ChooseElement =  ()=>{
    return (
        <div className="container">
            カードを選択する際にカードが選択可能かを調べます
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_choose.png`}></img></p>
            上記の例では効果を受けないカードが選択されないことを示します
        </div>
    )
}
